export interface EquipmentImage {
  id: string;
  equipment_id?: string;
  image_url: string;
  is_main?: boolean;
  display_order?: number;
}

export interface Equipment {
  id: string;
  name?: string;
  ownReference: string;
  location: string;
  productionMonth: number | null;
  productionYear: string | null;
  make: string;
  model: string;
  serialNumber: string;
  segment: string;
  mastType: string;
  imageUrl: string;
  addedDate: Date;
  extendImages?: EquipmentImage[];

  // Real backend API fields
  userId?: string;
  equipmentModelId?: string;
  equipmentModelPrefixId?: string;
  brandId?: string;
  brandNameManual?: string;
  modelNameManual?: string;
  licensePlate?: string;
  hourMeter?: number;
  status?: string;
  notes?: string;

  // Thông tin khung gầm
  chassisSerialNumber?: string;

  // Thông tin động cơ
  engineBrand?: string;
  engineModel?: string;
  engineSerialNumber?: string;

  // Thông tin hộp số
  transmissionBrand?: string;
  transmissionModel?: string;
  transmissionSerialNumber?: string;

  // Thông tin cầu xe
  axleBrand?: string;
  axleModel?: string;
  axleSerialNumber?: string;

  // Thông tin khung nâng
  mastModel?: string;
  mastSerialNumber?: string;

  // Thông tin chung
  origin?: string;

  // Nhiên liệu & Tải trọng
  fuelType?: string;
  capacity?: string;

  // Tire information
  steeringTireSize?: string;
  steeringTireType?: string;
  loadTireSize?: string;
  loadTireType?: string;
  spareTireSize?: string;
  spareTireType?: string;
}

export interface EquipmentModel {
  model: string;
  startDate: string;
  id?: string;
  brandId?: string;
}

export interface EquipmentMastOption {
  code: string;
  description: string;
}

export interface EquipmentMake {
  name: string;
  models: EquipmentModel[];
  mastOptions: EquipmentMastOption[];
  id?: string;
}

export interface EquipmentPartPackage {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  parts: EquipmentPart[];
  totalPrice: number;
  currency: string;
}

export interface EquipmentPart {
  id: string;
  name: string;
  code: string;
  brand: string;
  price: number;
  currency: string;
  imageUrl: string;
  quantity: number;
  sourceType?: 'custom_product' | 'part_package_item';
  sourceRefId?: string;
  myEquipmentId?: string;
  // Product classification (if any)
  productTypeId?: string | null;
  productTypeText?: string | null;
  productTypeName?: string | null;
  isRequired?: boolean;
  // UI state: whether this part is ticked by the user when buying a package
  selected?: boolean;
  // Purchase history source label (part package it was bought from, if any)
  partPackageId?: string | null;
  partPackageName?: string | null;
  partPackageDescription?: string | null;
  partPackageImage?: string | null;
}

export interface EquipmentPurchaseHistory {
  id: string;
  date: Date;
  orderCode: string;
  parts: EquipmentPart[];
  totalPrice: number;
  currency: string;
  status: string;
}

export interface RecentMakeModelSearch {
  make: string;
  model: string;
  segments: string[];
  serialRange: string;
}


export const EQUIPMENT_FUEL_TYPES: string[] = ['Điện', 'Gas', 'Dầu', 'DUAL'];


export const EQUIPMENT_ORIGINS: string[] = [
  'Japan',
  'China',
  'Korea',
  'Germany',
  'USA',
  'Vietnam',
  'Taiwan',
  'Thailand',
  'India',
  'Other'
];


export const EQUIPMENT_PRODUCTION_MONTHS: number[] = Array.from({ length: 12 }, (_, i) => i + 1);


export function parseProductionDate(value: string | null | undefined): {
  month: number | null;
  year: string;
} {
  if (!value) {
    return { month: null, year: '' };
  }

  const text = ('' + value).trim();
  const match = text.match(/^(\d{1,2})\s*\/\s*(\d{4})$/);

  if (match) {
    const month = parseInt(match[1], 10);
    return {
      month: month >= 1 && month <= 12 ? month : null,
      year: match[2]
    };
  }

  return { month: null, year: text };
}


export function buildProductionDate(
  month: number | null | undefined,
  year: string | number | null | undefined
): string | null {
  const yearText = year != null ? ('' + year).trim() : '';

  if (!yearText) {
    return null;
  }

  if (month && month >= 1 && month <= 12) {
    return ('' + month).padStart(2, '0') + '/' + yearText;
  }

  return yearText;
}
